import { useFormikContext } from "formik";
import Switch from "pages/business/Subscription/Switch";
import BasicSelect from "components/BasicInputs/BasicSelect";
import { apiGetWarehouses } from "api/warehouseApi";
import { useAppDispatch, useAppSelector } from "../../../../store/store";
import useResponsive from "helpers/useResponsive";

export default function Remittance() {
  const dispatch = useAppDispatch();
  const store = useAppSelector((x: any) => x);
  const data = useFormikContext<MaterialOrderData>();
  const token = store.businessReducer.business.token;
  const { isMobile } = useResponsive();

  return (
    <div className={`${isMobile && "px-3"}`}>
      <div className="flex gap-3">
        <Switch
          size={2}
          active={data.values.automaticRemmitance}
          onChange={(v) => {
            data.setFieldValue("automaticRemmitance", v);
          }}
        />
        <span className="text-base font-medium">صدور اتوماتیک حواله انبار</span>
      </div>
      {data.values.automaticRemmitance ? (
        <div className="mt-6 w-80">
          <BasicSelect
            options={store.warehouseReducer.warehouses}
            label="انتخاب انبار محصول تولید شده"
            required
            withSearch
            withRefresh
            withClear
            defaultValue={data.values.remmitanceWarehouseId}
            refreshList={() => dispatch(apiGetWarehouses(token))}
            onChange={(val, option: Product) => {
              data.setFieldValue("remmitanceWarehouseId", val);
              data.setFieldValue("remmitanceWarehouse", option);
            }}
            onClear={() => {
              data.setFieldValue("remmitanceWarehouseId", undefined);
              data.setFieldValue("remmitanceWarehouse", undefined);
            }}
          />
        </div>
      ) : (
        <p className="text-dark-3 w-[300px] mt-[24px] leading-[29px]">
          با فعال کردن این گزینه زمانی که سفارش تولید پایان می یابد رسید ورود به انبار محصولات ساخته می شود.
        </p>
      )}
    </div>
  );
}
